import { render, staticRenderFns } from "./activitiesDetail2023zz.vue?vue&type=template&id=5f30cf8c&scoped=true"
import script from "./activitiesDetail2023zz.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2023zz.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2023zz.vue?vue&type=style&index=0&id=5f30cf8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f30cf8c",
  null
  
)

export default component.exports